import { getRuleMatchResult, IpasswordForce, IpasswordRule, isMatchForceResultConfig, MatchResultConfig, passwordBreakKey } from './passwordUtil';
import { CSSProperties, FC, useState } from 'react';

interface props {
	color?: string;
	style?: CSSProperties;
	className?: string;
	customRule?: IpasswordRule[];
}
enum ForceMap {
	high = '密码安全',
	middle = '密码普通',
	low = '密码简单',
}
const boolNumSum = (list: boolean[]) => list.reduce<number>((previousValue, currentValue) => (currentValue ? previousValue + 1 : previousValue), 0);

const usePasswordForce: (props?: props) => {
	View: FC<{ color?: string }>;
	validate: (inputValue: string) => boolean;
	force: IpasswordForce;
} = props => {
	const { customRule = [] } = props ?? {};
	const [force, setforce] = useState<IpasswordForce>(false);

	const validate = (inputValue: string) => {
		setforce(false);
		const inputValueLen = inputValue?.length || 0;
		const isFirstWordUp = inputValueLen > 0 && inputValue[0] === inputValue[0].toLocaleUpperCase();
		const ruleRsult = getRuleMatchResult(customRule, inputValue, undefined, '');
		const matchNum = boolNumSum(ruleRsult.list.map(e => e[passwordBreakKey]));
		const matchResultConfig: MatchResultConfig[] = [
			{ min: 0, max: 32, matchNum: 1, value: 'low' },
			{ min: 0, max: 7, matchNum: 2, value: 'low' },
			{ min: 7, max: 32, matchNum: 2, value: 'middle' },
			{ min: 7, max: 32, matchNum: 3, value: 'middle' },
			{ min: 15, max: 32, matchNum: 3, value: 'high', need: isFirstWordUp },
		];
		matchResultConfig.forEach(config => {
			isMatchForceResultConfig(config, matchNum, inputValueLen) && setforce(config.value);
		});
		return ruleRsult.invaildWord;
	};

	return {
		View: ({ color }) => (force ? <span style={{ color }}>{ForceMap[force]}</span> : null),
		validate,
		force,
	};
};

export default usePasswordForce;
